import apiCallTemplate from "./config";
import credentials from "../assets/credentials";

const { BASE_URL } = credentials;
const assetURL = `${BASE_URL}/assets`;

//list Asset
export const listAsset = async (assetData, file) =>
  apiCallTemplate("post", `${assetURL}`, assetData, file);

//Get all assets [use query params to get filtered data and include page=num and limit=num for pagination]
export const allAssets = async (query) =>
  apiCallTemplate("get", `${assetURL}${query || ""}`);

//Search assets [use query params]
export const searchAsset = async (query) =>
  apiCallTemplate("get", `${assetURL}/get/search${query || ""}`);

//Get assets by category name [include page=num and limit=num for pagination]
export const getAssetsByCategoryName = async (platformName, catName, query) =>
  apiCallTemplate(
    "get",
    `${assetURL}/categories/${platformName}/${catName || "assets"}${query || ""}`,
  );

//Get user assets by username [include page=num and limit=num for pagination]
export const getAssetsByUsername = async (username, query) =>
  apiCallTemplate("get", `${assetURL}/my-assets/${username}${query}`);

//Get asset by id
export const getAsset = async (id) =>
  apiCallTemplate("get", `${assetURL}/${id}`);

//Get Asset Image
export const assetImage = async (imageNodeId) =>
  apiCallTemplate("get", `${assetURL}/image/view/${imageNodeId}`);

//Update Asset
export const updateAsset = async (id, assetData, file) =>
  apiCallTemplate("put", `${assetURL}/${id}`, assetData, file);

//Delete Asset
export const deleteAsset = async (id) =>
  apiCallTemplate("delete", `${assetURL}/${id}`);

//get Assets stats [use query params]
export const getAssetstats = async (searchInputs) =>
  apiCallTemplate("get", `${assetURL}/stats${searchInputs || ""}`);

//get Assets stats [use query params]
export const allAssetstats = async () =>
  apiCallTemplate("get", `${assetURL}/get/stats`);
